/**
 * What: Page- and editor-level merchant-facing copy for the Study Builder (the page shell, the in-app product picker,
 *   and the server-owned study status badge labels).
 * Transport / data-flow: Pure string dictionary segment spread into the study copy (study.ts) for Shopify UI and the
 *   Worker. The page is a dumb renderer: these words are the only place fixed English copy for the shell may live.
 */
export const studyBuilderPageCopy = {
    studyBuilderPage: {
        newTestHeading: 'New test',
        untitledHeading: 'Test',
        testsBack: 'Tests',
        startedHeading: 'This test has started',
        startedBody: 'Its settings can no longer be edited. Create a new draft to make changes.',
        refreshSetupFailed: 'The latest saved setup could not be loaded. Your edits are kept.',
        reviewAndRun: 'Review and run',
        statusLoadFailed: 'The latest test status could not be loaded.',
        supportHeading: 'This test needs support',
        supportBody: 'The test did not finish. Our support team can review the run details and help resolve it.',
        newerVersion: 'A newer saved version is available. Your unsaved changes are still here.',
        keepEditing: 'Keep editing',
        loadSavedVersion: 'Load saved version',
        actionBusy: 'Please wait for the current action to finish.',
        changesDiscarded: 'Changes discarded',
        couldNotLeave: 'Your changes are kept. Try leaving the page again.',
        couldNotRestoreSaveBar: 'Your changes are kept, but the save controls could not be shown.',
        helpHeading: 'Need help with your test?',
        bookHelp: 'Book a test review',
        notFoundTitle: "We couldn't find this test",
        notFound: 'It may have been deleted, or the link is out of date.',
        invalidDataTitle: "This saved test can't be opened",
        invalidData: 'Go back to Tests and start a new one.',
        unsupportedVersionTitle: 'This saved test was made with an older version',
        conflictTitle: "This test doesn't match your store",
        conflict: 'Go back to Tests and open it again.',
        unexpectedTitle: "This test can't be opened right now",
        unexpected: 'Go back to Tests and try again. If it keeps happening, get in touch.',
        networkTitle: "We couldn't load this test",
        networkBody: 'Check your connection, then try again.',
        notAllowedTitle: "You don't have access to this test",
        notAllowedBody: 'It may belong to a different store. Go back to Tests.',
        alreadyRunning: 'This test is already running. Open it from Tests to follow its progress.',
        alreadyComplete: 'This test has already finished. Open it from Tests to see the results.',
        changesSaved: 'Changes saved',
        studySubmitted: 'Test submitted',
        legacyRouteRetired: 'This saved setup link is no longer supported. Open a test from Tests.',
        directStudyLoadFailed: 'The test could not be loaded.',
        deletionInProgress: 'This test is being deleted.',
        identityMissing: 'The test identity is missing.',
        restoreFailed: 'The saved test could not be restored.',
        evaluationFailed: 'The test could not be checked. Your changes are still here.',
        untitledTest: 'Untitled test',
        deletionTitle: 'Test deletion',
        deletingTitle: 'Deleting test',
        deletingBody: 'Deletion is still in progress. You can leave this page and check it from Tests.',
        deletionFailedTitle: 'Deletion needs attention',
        deletionFailedBody: 'Deletion could not finish. Try deleting it again.',
        deletionStatusFailed: 'The deletion status could not be checked.',
        deletedTitle: 'This test has been deleted',
        deletedBody: 'This test is no longer available. Go back to Tests to open or create another test.',
    },
    /** The native Shopify product chooser; failures never open a second picker. */
    studyBuilderProductPicker: {
        openFailed: "Shopify's product picker could not open. Try choosing a product again.",
    },
    /** The merchant-facing badge label for each server-owned study state; one owner for builder and Tests. */
    studyAuthoringStatus: {
        deleting: 'Deleting',
        draft: 'Draft',
        preparing: 'Preparing',
        ready: 'Ready',
        running: 'Running',
        complete: 'Complete',
        failed: 'Failed',
        needsChanges: 'Needs changes',
        deletionNeedsAttention: 'Deletion needs attention',
    },
};
//# sourceMappingURL=study-builder-page.js.map